import { fetchCurrentIdToken } from "./util/login";

const apiConfig = {
  Auth: {
    Cognito: {
      userPoolClientId: process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID,
      userPoolId: process.env.REACT_APP_AWS_USER_POOLS_ID,
      loginWith: {
        oauth: {
          domain: process.env.REACT_APP_OAUTH_DOMAIN,
          scopes: ['openid', 'profile', 'aws.cognito.signin.user.admin'],
          redirectSignIn: [process.env.REACT_APP_SIGNIN],
          redirectSignOut: [process.env.REACT_APP_SIGNOUT],
          responseType: 'code',
        },
        username: 'true',
        email: 'false',
        phone: 'false',
      }
    }
  },
  API: {
    GraphQL: {
      endpoint: process.env.REACT_APP_API_URL,
      region: process.env.REACT_APP_API_REGION,
      defaultAuthMode: process.env.REACT_APP_API_AUTHTYPE
    },
    Events: {
      endpoint: process.env.REACT_APP_API_EVENTS_URL,
      region: process.env.REACT_APP_API_REGION,
      defaultAuthMode: process.env.REACT_APP_API_AUTHTYPE
    }
  },
  Analytics: {
    disabled: true,
  }
};

// console.log("apiConfig: ", apiConfig);
const libraryOptions = {
  API: {
    GraphQL: {
      headers: async () => ({
        Authorization: await fetchCurrentIdToken()
      })
    },
    Events: {
      headers: async () => ({
        Authorization: await fetchCurrentIdToken()
      })
    }
  },
};

export { apiConfig, libraryOptions };